import ListingType from './listing-type';
var ListingSortOrder = {
  PRICE_ASCENDING: {
    value: 'price-asc',
    label: 'Price (Low - High)',
    urlSlug: 'lowest-price'
  },
  PRICE_DESCENDING: {
    value: 'price-desc',
    label: 'Price (High - Low)',
    urlSlug: 'highest-price'
  },
  LISTING_AGE_ASCENDING: {
    value: 'dateupdated-asc',
    label: 'Listing Age (Oldest - Newest)',
    urlSlug: 'oldest-listing'
  },
  LISTING_AGE_DESCENDING: {
    value: 'dateupdated-desc',
    label: 'Listing Age (Newest - Oldest)',
    urlSlug: 'newest-listing'
  },
  UPCOMING_INSPECTIONS: {
    value: 'inspectiontime-asc',
    label: 'Upcoming inspections',
    urlSlug: 'inspectiontime-asc',
    listingTypes: [ListingType.SALES_RESIDENTIAL.name, ListingType.RENTAL_RESIDENTIAL.name, ListingType.SALES_BUSINESS.name, ListingType.SALES_COMMERCIAL.name, ListingType.RENTAL_COMMERCIAL.name]
  },
  UPCOMING_AUCTIONS: {
    value: 'auction-asc',
    label: 'Upcoming auctions',
    urlSlug: 'earliest-auction',
    listingTypes: [ListingType.SALES_RESIDENTIAL.name, ListingType.SALES_COMMERCIAL.name, ListingType.SALES_BUSINESS.name]
  },
  LOCATION_ASCENDING: {
    value: 'address-asc',
    label: 'Location (A - Z)',
    urlSlug: 'address-asc'
  },
  LOCATION_DESCENDING: {
    value: 'address-desc',
    label: 'Location (Z - A)',
    urlSlug: 'address-dec'
  },
  PROPERTY_TYPE_ASCENDING: {
    value: 'propertytype-asc',
    label: 'Property Type (A - Z)',
    urlSlug: 'propertytype-asc'
  },
  PROPERTY_TYPE_DESCENDING: {
    value: 'propertytype-desc',
    label: 'Property Type (Z - A)',
    urlSlug: 'propertytype-desc'
  },
  BEDROOMS_ASCENDING: {
    value: 'bedrooms-asc',
    label: 'Bedrooms (Min - Max)',
    urlSlug: 'bedrooms-asc',
    listingTypes: [ListingType.SALES_RESIDENTIAL.name, ListingType.RENTAL_RESIDENTIAL.name]
  },
  BEDROOMS_DESCENDING: {
    value: 'bedrooms-desc',
    label: 'Bedrooms (Max - Min)',
    urlSlug: 'bedrooms-desc',
    listingTypes: [ListingType.SALES_RESIDENTIAL.name, ListingType.RENTAL_RESIDENTIAL.name]
  },
  ROOMS_AVAILABLE_ASCENDING: {
    value: 'roomsavailable-asc',
    label: 'Rooms Available (Min - Max)',
    urlSlug: 'roomsavailable-asc',
    listingTypes: [ListingType.SHARE_RESIDENTIAL.name]
  },
  ROOMS_AVAILABLE_DESCENDING: {
    value: 'roomsavailable-desc',
    label: 'Rooms Available (Max - Min)',
    urlSlug: 'roomsavailable-desc',
    listingTypes: [ListingType.SHARE_RESIDENTIAL.name]
  },
  PEOPLE_WANTED_ASCENDING: {
    value: 'peoplewanted-asc',
    label: 'People Wanted (Min - Max)',
    urlSlug: 'peoplewanted-asc',
    listingTypes: [ListingType.SHARE_RESIDENTIAL.name]
  },
  PEOPLE_WANTED_DESCENDING: {
    value: 'peoplewanted-desc',
    label: 'People Wanted (Max - Min)',
    urlSlug: 'peoplewanted-desc',
    listingTypes: [ListingType.SHARE_RESIDENTIAL.name]
  }
};
export default ListingSortOrder;